import React from 'react';
import { Progress } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard } from '@fortawesome/free-solid-svg-icons';
//import { ContractStatus, _ContractStatuses } from './Contract';
import {
    createDataSource,
    createGridOptions,
    DataGrid,
    indexCellRenderer,
    TextFilterDefaults,
    LinkCellRenderer,
    ButtonCellRenderer,
    PermissionButtonCellRenderer,
} from '../common/dataGrid/DataGrid';
import DataGridSelectFilter from '../common/dataGrid/DataGridSelectFilter';
import CommonContext, { ApiRoutes, ApplicationPermissions, AppNavPaths } from '../Common';
import { PageHeading, PageWrap } from '../common/forms/FormElements';
import DataGridSelectFloatingFilter from '../common/dataGrid/DataGridSelectFloatingFilter';
import DataGridToolbar from '../common/dataGrid/DataGridToolbar';
import authService from '../api-authorization/AuthorizeService';

class EstimateIndex extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            rowData: [],
            selectedRow: null,
        };
        this.onAddContract = this.onAddContract.bind(this);
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.populateState());
        this.populateState();
    }

    onAddContract = (salesOrder) => {
        this.context.history.push({
            pathname: AppNavPaths.ContractNew,
            state: { salesOrder },
        });
    };

    async populateState() {
        const isAuthenticated = await authService.isAuthenticated();

        if (isAuthenticated) {
            const gridOptions = createGridOptions(this);

            gridOptions.components = {
                selectFilter: DataGridSelectFilter,
                selectFloatingFilter: DataGridSelectFloatingFilter,
                nameRenderer: LinkCellRenderer,
                buttonRenderer: ButtonCellRenderer,
                permissionButtonRenderer: PermissionButtonCellRenderer,
            };
            gridOptions.columnDefs = [
                {
                    flex: 0,
                    maxWidth: 35,
                    headerName: '',
                    valueGetter: 'node.id',
                    sortable: false,
                    cellRenderer: indexCellRenderer,
                }, {
                    colId: 'CustomerName',
                    flex: 2,
                    headerName: 'Customer Name',
                    field: 'customer_name',
                    sortable: true,
                    filter: 'agTextColumnFilter',
                    filterParams: TextFilterDefaults,
                    floatingFilterComponentParams: {
                        suppressFilterButton: true,
                    },
                },
                {
                    colId: 'EstimateNumber',
                    maxWidth: 150,
                    headerName: 'Estimate #',
                    field: 'estimate_number',
                    sortable: true,
                    filter: 'agTextColumnFilter',
                    filterParams: TextFilterDefaults,
                    floatingFilterComponentParams: {
                        suppressFilterButton: true,
                    },
                    cellRenderer: (params) => {
                        if (params.data) {
                            return (
                                <a
                                    className="site-link"
                                    href={params.data.est_link}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {params.data.estimate_number}</a>
                            );
                        }
                        return null;
                    },
                }, {
                    colId: 'SalesOrderNumber',
                    maxWidth: 151,
                    headerName: 'Sales Order #',
                    field: 'so_number',
                    sortable: true,
                    filter: 'agTextColumnFilter',
                    filterParams: TextFilterDefaults,
                    floatingFilterComponentParams: {
                        suppressFilterButton: true,
                    },
                    cellRenderer: (params) => {
                        if (params.data) {
                            return (
                                <a
                                    className="site-link"
                                    href={params.data.so_link}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {params.data.so_number}</a>
                            );
                        }
                        return null;
                    },
                }, {
                    colId: 'PoNumber',
                    headerName: 'PO #',
                    field: 'customer_po_number',
                    sortable: true,
                    filter: 'agTextColumnFilter',
                    filterParams: TextFilterDefaults,
                    floatingFilterComponentParams: {
                        suppressFilterButton: true,
                    },
                }, {
                    colId: 'EstimateDate',
                    headerName: 'Estimate Date',
                    field: 'estimate_date',
                    sortable: true,
                }, {
                    colId: 'EstimateMemo',
                    headerName: 'Estimate Memo',
                    field: 'estimate_memo',
                    sortable: true,
                }, {
                    colId: 'Status',
                    headerName: 'Status',
                    field: 'status',
                    sortable: true,
                }, {
                    colId: 'Subtotal',
                    headerName: 'Subtotal',
                    field: 'subtotal',
                    sortable: true,
                }, {
                    colId: 'total',
                    headerName: 'Total',
                    field: 'total',
                    sortable: true,
                }, {
                    colId: 'CreatedBy',
                    headerName: 'Created By',
                    field: 'created_by',
                    sortable: true,
                },
                {
                    colId: 'AddContract',
                    flex: 0,
                    maxWidth: 140,
                    headerName: '',
                    field: 'status',
                    sortable: false,
                    cellRenderer: 'permissionButtonRenderer',
                    cellRendererParams: (r) => ({
                            clicked: () => this.onAddContract(r.data),
                            title: 'Create a Contract',
                            buttonText: 'New Contract',
                            action: 'create',
                            category: 'contract',
                        }),
                },
            ];


            const dataSource = createDataSource(
                ApiRoutes.estimates.search(),
                gridOptions,
            );

            this.setState({
                loading: false,
                gridOptions,
                dataSource,
            });
        }
    }

    render() {
        if (this.state.loading) return <Progress />;

        const { rowData, gridOptions } = this.state;

        const exportEstimatePermissions = this.context.checkUserHasPermission(ApplicationPermissions.contract_export);
        return (
            <PageWrap>
                <PageHeading>
                    <FontAwesomeIcon
                        icon={faAddressCard}
                        className="mr-2 text-muted"
                    />
                    <span>Estimates</span>
                </PageHeading>
                <DataGridToolbar
                    entity="contract"
                    hideExcelButton
                    hideAdd
                    gridOptions={this.state.gridOptions}
                    gridApi={this.state.gridApi}
                    dataSource={this.state.dataSource}
                    serverExportDisabled={!exportEstimatePermissions}
                />
                <DataGrid
                    domLayout="normal"
                    rowData={rowData}
                    gridOptions={gridOptions}
                    gridStatus={this.state.gridStatus}
                />
            </PageWrap>
        );
    }
}
export default EstimateIndex;
